export const normalizePaginatedResponse = (payload) => {
  if (!payload) {
    return {
      data: [],
      page: 1,
      pageSize: 0,
      total: 0,
      totalPages: 0,
      hasNext: false,
    };
  }

  if (Array.isArray(payload)) {
    const total = payload.length;
    return {
      data: payload,
      page: 1,
      pageSize: total,
      total,
      totalPages: total > 0 ? 1 : 0,
      hasNext: false,
    };
  }

  const data = Array.isArray(payload.data) ? payload.data : [];
  const page = Number.isFinite(payload.page) ? payload.page : 1;
  const pageSize = Number.isFinite(payload.pageSize) ? payload.pageSize : data.length;
  const total = Number.isFinite(payload.total) ? payload.total : data.length;
  const totalPages =
    Number.isFinite(payload.totalPages)
      ? payload.totalPages
      : pageSize > 0
        ? Math.ceil(total / pageSize)
        : 0;
  const hasNext =
    typeof payload.hasNext === "boolean"
      ? payload.hasNext
      : totalPages > 0
        ? page < totalPages
        : false;

  return {
    data,
    page,
    pageSize,
    total,
    totalPages,
    hasNext,
  };
};
